export const firmaIndexSortOrderKey = "firma-index-sort-order";
export const kursusIndexSortOrderKey = "kursus-index-sort-order";
export const linjeIndexSortOrderKey = "linje-index-sort-order";
export const personIndexSortOrderKey = "person-index-sort-order";
export const personIndexActiveColumnsKey = "person-index-active-columns";
